export default __webpack_public_path__ + "static/media/html-5.bf6bb1c2.svg";